var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 49,
    viewBox: "0 0 31 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37999 47.29C3.37999 46.3566 2.62335 45.6 1.68999 45.6C0.756626 45.6 -1.14671e-07 46.3566 -7.3872e-08 47.29C-3.30735e-08 48.2233 0.756626 48.98 1.68999 48.98C2.62335 48.98 3.37999 48.2233 3.37999 47.29Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37999 32.0898C3.37999 31.1564 2.62335 30.3998 1.68999 30.3998C0.756626 30.3998 -1.14671e-07 31.1564 -7.38724e-08 32.0898C-3.30738e-08 33.0231 0.756626 33.7798 1.68999 33.7798C2.62335 33.7798 3.37999 33.0231 3.37999 32.0898Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37999 16.8901C3.37999 15.9567 2.62335 15.2001 1.68999 15.2001C0.756626 15.2001 -1.14671e-07 15.9567 -7.38724e-08 16.8901C-3.30738e-08 17.8234 0.756626 18.5801 1.68999 18.5801C2.62335 18.5801 3.37999 17.8234 3.37999 16.8901Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37999 1.69012C3.37999 0.756763 2.62335 0.000121956 1.68999 0.000121996C0.756626 0.000122037 -1.14671e-07 0.756763 -7.38724e-08 1.69012C-3.30738e-08 2.62349 0.756626 3.38013 1.68999 3.38013C2.62335 3.38013 3.37999 2.62349 3.37999 1.69012Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.89 47.29C16.89 46.3566 16.1334 45.6 15.2 45.6C14.2667 45.6 13.51 46.3566 13.51 47.29C13.51 48.2233 14.2667 48.98 15.2 48.98C16.1334 48.98 16.89 48.2233 16.89 47.29Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.89 32.0898C16.89 31.1564 16.1334 30.3998 15.2 30.3998C14.2667 30.3998 13.51 31.1564 13.51 32.0898C13.51 33.0231 14.2667 33.7798 15.2 33.7798C16.1334 33.7798 16.89 33.0231 16.89 32.0898Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.89 16.8901C16.89 15.9567 16.1334 15.2001 15.2 15.2001C14.2667 15.2001 13.51 15.9567 13.51 16.8901C13.51 17.8234 14.2667 18.5801 15.2 18.5801C16.1334 18.5801 16.89 17.8234 16.89 16.8901Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.89 1.69012C16.89 0.756763 16.1334 0.000121956 15.2 0.000121996C14.2667 0.000122037 13.51 0.756763 13.51 1.69012C13.51 2.62349 14.2667 3.38013 15.2 3.38013C16.1334 3.38013 16.89 2.62349 16.89 1.69012Z",
    fill: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 47.29C30.4 46.3566 29.6434 45.6 28.71 45.6C27.7767 45.6 27.02 46.3566 27.02 47.29C27.02 48.2233 27.7767 48.98 28.71 48.98C29.6434 48.98 30.4 48.2233 30.4 47.29Z",
    fill: "#333333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 32.0898C30.4 31.1564 29.6434 30.3998 28.71 30.3998C27.7767 30.3998 27.02 31.1564 27.02 32.0898C27.02 33.0231 27.7767 33.7798 28.71 33.7798C29.6434 33.7798 30.4 33.0231 30.4 32.0898Z",
    fill: "#333333"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 16.8901C30.4 15.9567 29.6434 15.2001 28.71 15.2001C27.7767 15.2001 27.02 15.9567 27.02 16.8901C27.02 17.8234 27.7767 18.5801 28.71 18.5801C29.6434 18.5801 30.4 17.8234 30.4 16.8901Z",
    fill: "#333333"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 1.69012C30.4 0.756763 29.6434 0.000121956 28.71 0.000121996C27.7767 0.000122037 27.02 0.756763 27.02 1.69012C27.02 2.62349 27.7767 3.38013 28.71 3.38013C29.6434 3.38013 30.4 2.62349 30.4 1.69012Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.29f5f8675f2ec0601ed9954cb6fa5d25.svg";
export { ForwardRef as ReactComponent };